import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

export default function AdminUsersPage({ userActivity, handleResetPassword }) {
  const formatLastSeen = (value) => {
    if (!value) return "Never";
    try {
      return new Date(value).toLocaleString();
    } catch {
      return "Unknown";
    }
  };

  const sortedUsers = [...userActivity].sort((a, b) => (b.login_count || 0) - (a.login_count || 0));

  return (
    <Card className="shadow-lg">
      <CardHeader className="border-b">
        <CardTitle>User Login Activity</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-100">
              <tr>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 border-b">Name</th>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 border-b">Email</th>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 border-b">Role</th>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 border-b">Login Count</th>
                <th className="px-4 py-3 text-left font-semibold text-slate-700 border-b">Last Access</th>
                <th className="px-4 py-3 text-right font-semibold text-slate-700 border-b">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortedUsers.map((user) => (
                <tr key={user.id} className="border-b hover:bg-slate-50">
                  <td className="px-4 py-3 font-medium text-slate-900">{user.name}</td>
                  <td className="px-4 py-3 text-slate-700">{user.email}</td>
                  <td className="px-4 py-3 capitalize text-slate-600">{user.role}</td>
                  <td className="px-4 py-3 text-slate-700">{user.login_count || 0}</td>
                  <td className="px-4 py-3 text-slate-600">{formatLastSeen(user.last_login_at)}</td>
                  <td className="px-4 py-3 text-right">
                    <Button size="sm" variant="ghost" className="text-amber-600" onClick={() => handleResetPassword(user.id)}>
                      <Lock className="w-4 h-4" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
